var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramVendorDetailIcon = function SvgTelegramVendorDetailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#748DA9",
    d: "M10 16.667a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333m0 1.667a8.333 8.333 0 1 1 0-16.667 8.333 8.333 0 0 1 0 16.667m-2.59-7.358-2.082-.65c-.45-.138-.453-.447.1-.67l8.111-3.133c.47-.192.738.051.586.658l-1.382 6.517c-.096.464-.376.575-.763.36l-2.126-1.572-.99.956c-.102.098-.185.182-.341.204-.156.02-.285-.026-.379-.284l-.724-2.393z"
  })));
};
export default SvgTelegramVendorDetailIcon;